<template>
  <q-page class="stretch-grid no-footer">
    <UserDetailsModal :module="module" v-if="open" />
    <Grid 
      id="instructorApprovalsGrid"
      :expandable="true"
      class="fit"
      :module="module" 
      :data="approvalList" 
      :columns="columnOptions"
      :loading="loadingData"
      :filterable="filterable"
      :pagination="paginationOptions"
      :onLaunch="selectInstructorUser"
      :onRequest="onFetch"
      :onExport="fetchInstructors">
      <template slot="col-item-status" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label small"
              :class="{
                  'blue' : props.value =='SUBMITTED' || props.value =='RESUBMITTED',
                  'green' :props.value =='APPROVED',
                  'red' : props.value =='REJECTED',
                  'yellow' : props.value =='EXPIRED',
                  'grey' : props.value =='NOT SUBMITTED'
              }">
                {{props.value}}
              </div>
      </template>
      <template slot="col-item-date_created" slot-scope="props">
        {{ moment(props.value).format("MMMM Do, YYYY h:mm A") }}
      </template>
      <template slot="col-item-expand" slot-scope="props">
        <div class="sessions-table">
          <div class="sl-row table-head">
            <div class="sl-col-9">
              Approval History
            </div>
          </div>
          <div class="sl-row table-columns">
            <div class="sl-col-3">
              Date Updated
            </div>
            <div class="sl-col-2">
              Status 
            </div>
            <div class="sl-col-4">
              Notes
            </div>
          </div>
          <div class="sl-row" v-for="approval in props.props.row.HISTORY" v-bind:key="approval.INSTRUCTOR_APPROVAL_ID">
            <div class="sl-col-3">
              {{ moment(approval.DATE_CREATED).format("MMMM Do, YYYY h:mm A") }}
            </div>
            <div class="sl-col-2">
              <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label small"
              :class="{
                  'blue' : approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 1 || approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 5,
                  'grey' : approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 6,
                  'yellow' : approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 4,
                  'green' : approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 2,
                  'red' : approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID == 3
              }">
                {{ lookupApprovalStatus(approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID) }}
              </div>
            </div>
            <div class="sl-col-4">
              {{ approval.NOTES }}
            </div>
          </div>
        </div>
      </template>
    </Grid>
  </q-page>
</template>

<script>
import Grid from '../components/Shared/Grid'
import UserDetailsModal from '../components/User/UserDetailsModal'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { api } from 'src/plugins/axios'
import { lkKey } from 'src/utils'
const moment = require('moment')

export default {
  name: 'InstructorApprovalsGrid',
  components: {
    Grid,
    UserDetailsModal
  },
  data () {
    return {
      filterable: false,
      // url: this.process.env.API + '/documents/upload',
      moment: moment,
      module: this.$route.meta.module,
      visibleColumns: null,
      paginationOptions: {
        rowsNumber: 0,
        rowsPerPage: 10,
        page: 1,
        sortBy: 'DATE_CREATED',
        descending:true
      },
      columnOptions: [
        { field: 'INSTRUCTOR_APPROVAL_ID', name: 'INSTRUCTOR_APPROVAL_ID', label: 'Approval', sortable: false, align:'left'},
        { field: 'INSTRUCTOR_NAME', name: 'INSTRUCTOR_NAME', label: 'Instructor', sortable: false, align:'left'},
        { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: false, align: 'left'},
        { field: 'DATE_CREATED', name: 'DATE_CREATED', label: 'Action Date', sortable: true, type:'datetime', align:'left'}
      ]
    }
  },
  computed: {
    ...mapGetters('approvals', [
      'approvalList'
    ]),
    ...mapState({
      open: state => state.users.userModal.open,
      userId: state => state.users.activeApproval.INSTRUCTOR_ID
    }),
    ...mapState('approvals', {
      loadingData: state => state.loadingData
    })
  },
  methods: {
    ...mapActions('approvals', [
      'fetchInstructors',
      'exportExcel'
    ]),
    ...mapActions('users', [
      'selectInstructorUser'
    ]),
    ...mapMutations('classes', [
      'updateAddEditClassOpenState',
      'updateModalMode',
      'updateModalLoading',
      'updateSessionInformation',
      'updateSelectedSession'
    ]),
    onFetch (options) {
      return this.fetchInstructors(options)
    },
    lookupApprovalStatus(approval_status_id) {
      return lkKey('LK_INSTRUCTOR_APPROVAL_STATUS_ID', approval_status_id)
    }
  }
}
</script>

<style lang="stylus">
  .sessions-table {
    .sl-row {
      border-bottom: 1px solid rgba(0,0,0,0.12)
      min-height: 40px;

      &:last-child {
        border-bottom: 0;
      }

      &.table-head {
        margin-bottom: 10px;

        div {
          padding-top: 5px;
          padding-bottom: 10px;
          font-weight: 600;
          font-size: 14px;
        }
      }

      &.table-columns {
        div {
          padding-bottom: 10px;
        }
      }

      div {
        text-align: center;
      }

      .q-btn {
        margin-top: -10px;
        margin-bottom: 10px;
      }
    }
  }
</style>